<template>
  <vxe-modal
    ref="modal"
    size="mini"
    v-model="formVisible"
    title="评价"
    width="300px"
    @show="showModal"
  >
    <el-form
      :model="form"
      ref="FormRef"
      :validate-on-rule-change="false"
      :rules="rules"
      size="mini"
    >
      <el-form-item label="评价" prop="assessResult">
        <el-select
          clearable
          v-model="form.assessResult"
          :placeholder="placeholderConfig.select"
          @change="assessChange()"
        >
          <el-option label="满足" value="满足"></el-option>
          <el-option label="不满足" value="不满足"></el-option>
        </el-select>
        <template slot="error" slot-scope="slot">
          <errorTooltip :content="slot.error"></errorTooltip>
        </template>
      </el-form-item>
      <el-form-item label="评价说明" prop="assessNote">
        <el-input
          type="textarea"
          v-model="form.assessNote"
          :placeholder="placeholderConfig.input"
          :disabled="form.assessResult === '满足'"
        ></el-input>
        <template slot="error" slot-scope="slot">
          <errorTooltip :content="slot.error"></errorTooltip>
        </template>
      </el-form-item>
    </el-form>
    <el-button
      @click="handleCommit"
      style="float: right; margin-top: 10px"
      size="mini"
      type="primary"
      >确认</el-button
    >
  </vxe-modal>
</template>
<script>
export default {
  name: 'AssessModal',
  data() {
    return {
      formVisible: false,
      form: {
        assessResult: '',
        assessNote: '',
      },
      rules: {
        assessResult: [
          { required: true, message: '请选择评价', trigger: 'change' }
        ],
        assessNote: [
          { validator: this.validNote, trigger: 'change' },
          {
            min: 0,
            max: 64,
            message: '长度在 0 到 64 个字符',
            trigger: 'change'
          }
        ]
      },
      // 是否限制当天之后时间不能选择
      isLimitToday: true,
      // 日期选择框配置项
      pickerOptions: null
    }
  },
  methods: {
    // 评价变化时
    assessChange() {
      // 满足时不能填写评价说明
      if (this.form.assessResult === '满足') {
        this.form.assessNote = ''
        this.$refs.FormRef.clearValidate()
      }
    },
    // 校验评价说明
    validNote(rule, value, callback) {
      if (this.form.assessResult === '不满足' && !value) {
        callback(new Error('当评价为不满足时评价说明为必填!'))
      } else {
        callback()
      }
    },
    showModal() {
      this.form = {
        assessResult: '',
        assessNote: '',
      }
      this.$nextTick(() => {
        this.$refs.FormRef.clearValidate()
      })
    },
    async handleCommit() {
      const valid = await this.validEnter()
      if (!valid) {
        this.$message.error('校验失败,请检查内容是否合法')
        return
      }
      this.$emit("sureHandler", this.form);
      this.$nextTick(() => {
        this.formVisible = false
      })
    },
    async validEnter() {
      let flag = false
      await this.$refs.FormRef.validate().then(
        res => {
          flag = res
        },
        err => {
          flag = err
        }
      )
      return flag
    },
  },
}
</script>
<style lang='less' scoped>
// vxemodal部分，美化标题太大的问题
/deep/ .vxe-modal--header {
  // font-size: 12px !important;
  height: 26px !important;
  padding: 2px 10px 0 10px !important;
}

// vxemodal关闭按钮
/deep/ .vxe-modal--close-btn {
  position: absolute !important;
  right: 8px !important;
  top: 6px !important;
  z-index: 1 !important;
  cursor: pointer !important;
}

// vxemodal标题
/deep/ .vxe-modal--title {
  font-size: 12px !important;
}
</style>